import { createCsvValidator } from '~/components/general/createCsvValidator';

export const groupsCsvValidator = createCsvValidator({
    maxFileSizeBytes: 100 * 1024 ** 2,
    requiredHeadings: ['group_id'],
});

export const validateGroupsCsv = groupsCsvValidator.validate;
